import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Observable, of, isObservable } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface ResponsableData {
  firstName?: string;
  lastName?: string;
  email?: string;
  tel?: string;
  adresse?: string;
  indication?: string;
}

@Component({
  selector: 'sm-dac-responsable-infos',
  imports: [CommonModule],
  templateUrl: './dac-responsable-infos.component.html',
  styleUrl: './dac-responsable-infos.component.scss',
})
export class DacResponsableInfosComponent {
  private _responsableData: Observable<ResponsableData | null | undefined> = of({
    firstName: '',
    lastName: '',
    email: '',
    tel: '',
    adresse: '',
    indication: '',
  });

  @Input() set responsableData(value: Observable<ResponsableData | null | undefined> | ResponsableData | null | undefined) {
    if (isObservable(value)) {
      this._responsableData = value.pipe(
        catchError(err => {
          console.error('DacResponsableInfosComponent: Error in responsableData observable', err);
          return of(null);
        })
      );
    } else {
      this._responsableData = of(value);
    }
  }

  get responsableData(): Observable<ResponsableData | null | undefined> {
    return this._responsableData;
  }
}
